module.exports = __webpack_public_path__ + "media/images/home/intro03-15a28ef2e897cd547e3457b9c7f96ba0.svg";